// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  FlattenedServiceLogResponse,
  FlattenedServiceLogResponseT,
  verifyFlattenedServiceLogResponse,
} from "./flattened-service-log-response";

export class FlattenedServiceLogResponses implements flatbuffers.IUnpackableObject<FlattenedServiceLogResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FlattenedServiceLogResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFlattenedServiceLogResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: FlattenedServiceLogResponses,
  ): FlattenedServiceLogResponses {
    return (obj || new FlattenedServiceLogResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFlattenedServiceLogResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: FlattenedServiceLogResponses,
  ): FlattenedServiceLogResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FlattenedServiceLogResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: FlattenedServiceLogResponse): FlattenedServiceLogResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new FlattenedServiceLogResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startFlattenedServiceLogResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endFlattenedServiceLogResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createFlattenedServiceLogResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FlattenedServiceLogResponses.startFlattenedServiceLogResponses(builder);
    FlattenedServiceLogResponses.addResults(builder, resultsOffset);
    return FlattenedServiceLogResponses.endFlattenedServiceLogResponses(builder);
  }

  unpack(): FlattenedServiceLogResponsesT {
    return new FlattenedServiceLogResponsesT(
      this.bb!.createObjList<FlattenedServiceLogResponse, FlattenedServiceLogResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: FlattenedServiceLogResponsesT): void {
    _o.results = this.bb!.createObjList<FlattenedServiceLogResponse, FlattenedServiceLogResponseT>(
      this.results.bind(this),
      this.resultsLength(),
    );
  }

  unpackFields(...fields: string[]): FlattenedServiceLogResponsesT {
    const t = new FlattenedServiceLogResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<FlattenedServiceLogResponse, FlattenedServiceLogResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      );
    }
    return t;
  }
}

export class FlattenedServiceLogResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: FlattenedServiceLogResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = FlattenedServiceLogResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return FlattenedServiceLogResponses.createFlattenedServiceLogResponses(builder, results);
  }

  clone(): FlattenedServiceLogResponsesT {
    const obj = new FlattenedServiceLogResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: FlattenedServiceLogResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyFlattenedServiceLogResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyFlattenedServiceLogResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
